export const withPartnerCode = (args = {}, partnerCode) => ({
  ...args,
  partnerCode: partnerCode || "",
});

export const buildFactorPriceArgs = ({
  insurancePlanId,
  factors,
  partnerCode,
}) =>
  withPartnerCode(
    {
      insurancePlanId,
      factors: { ...(factors || {}) },
    },
    partnerCode,
  );

export const buildBatchFactorPriceArgs = ({
  insurancePlanId,
  partnerCode,
  variants,
}) =>
  withPartnerCode(
    {
      insurancePlanId,
      variants: (variants || []).map((variant) => ({
        source: variant.source,
        factors: { ...(variant.factors || {}) },
      })),
    },
    partnerCode,
  );
